import { AxiosResponse } from "axios";
import { SupplyConfigurationRequest, SupplyConfigurationSaveRequest } from "@/main/models/request";
import { SupplyConfigurationGetAllResponse, SupplyConfigurationResponse } from "@/main/models/response";
import { Result } from "@/main/models/common/resultResponse";

export abstract class ISupplyConfigurationApi {
	abstract getbysupplier(
		request: SupplyConfigurationRequest,
	): Promise<AxiosResponse<Result<SupplyConfigurationResponse[]>>>;

	abstract getAll(
		request: SupplyConfigurationRequest,
	): Promise<AxiosResponse<Result<SupplyConfigurationGetAllResponse[]>>>;

	abstract saveSupplyConfiguration(request: SupplyConfigurationSaveRequest): Promise<AxiosResponse<Result<any>, any>>;
}
